// extracted by mini-css-extract-plugin
module.exports = {"favoriteCompanyBox":"styles_favoriteCompanyBox__2TGmG","favoriteCompanyBoxHeader":"styles_favoriteCompanyBoxHeader__2fcYV","spacer":"styles_spacer__1ANWT"};